import React, { Component } from 'react'
import { Image, YellowBox } from 'react-native'

import * as Font from 'expo-font'
import { Asset } from 'expo-asset'

import { init } from './src/redux/device'
import CenteredSpinner from './src/components/Atoms/Spinner/CenteredSpinner'
import { initDownloadedFiles } from './src/redux/files'
import configureStore from './src/store/create-store'
import BatteryService from './src/services/battery'

import ActualApp from './src/app'

YellowBox.ignoreWarnings([
  'Warning: componentWillMount is deprecated',
  'Warning: componentWillMount has been renamed',
  'Warning: componentWillReceiveProps is deprecated',
  'Warning: componentWillReceiveProps has been renamed',
  'Battery.isSupported',
  'Require cycle',
  'getNode',
  'useNativeDriver'
])

const store = configureStore()

function cacheImages (images) {
  return images.map(image => {
    if (typeof image === 'string') {
      return Image.prefetch(image)
    } else {
      return Asset.fromModule(image).downloadAsync()
    }
  })
}

class App extends Component {
  state = {
    initialised: false
  }

  async componentDidMount () {
    await Promise.all([
      Font.loadAsync({
        'ubuntu-bold': require('./src/assets/fonts/Ubuntu-Bold.ttf'),
        'ubuntu-medium': require('./src/assets/fonts/Ubuntu-Medium.ttf'),
        'ubuntu-light': require('./src/assets/fonts/Ubuntu-Light.ttf'),
        ubuntu: require('./src/assets/fonts/Ubuntu-Regular.ttf'),
        'sf-orson-casual-light': require('./src/assets/fonts/SF-Orson-Casual-Light.ttf'),
        proxima: require('./src/assets/fonts/ProximaNovaExCn-Reg.otf'),
        'proxima-bold': require('./src/assets/fonts/ProximaNovaExCn-Bold.otf'),
        'opensans-semibold': require('./src/assets/fonts/OpenSans-SemiBold.ttf'),
        raleway: require('./src/assets/fonts/Raleway-Regular.ttf')
      }),
      cacheImages([
        require('./src/assets/app-icon.png'),
        require('./src/assets/checkbox.png'),
        require('./src/assets/logo.png'),
        require('./src/assets/radio.png'),
        require('./src/assets/selected_checkbox.png'),
        require('./src/assets/selected_radio.png'),

        require('./src/assets/images/projects/completed.png'),
        require('./src/assets/images/projects/project1.jpg'),
        require('./src/assets/images/projects/project2.jpg'),
        require('./src/assets/images/projects/project3.jpg'),
        require('./src/assets/images/projects/project4.jpg'),
        require('./src/assets/images/projects/project5.jpg'),
        require('./src/assets/images/projects/project6.jpg'),
        require('./src/assets/images/projects/project7.jpg'),
        require('./src/assets/images/projects/project8.jpg'),
        require('./src/assets/images/projects/project9.jpg'),
        require('./src/assets/images/projects/project10.jpg'),
        require('./src/assets/images/projects/project11.jpg'),
        require('./src/assets/images/projects/project12.jpg'),
        require('./src/assets/images/projects/project13.jpg'),
        require('./src/assets/images/projects/project14.jpg'),
        require('./src/assets/images/projects/project15.jpg'),
        require('./src/assets/images/projects/project16.jpg'),
        require('./src/assets/images/projects/project17.jpg'),
        require('./src/assets/images/projects/selected.png'),

        require('./src/assets/images/exco/exco1.jpg'),
        require('./src/assets/images/exco/exco2.jpg'),
        require('./src/assets/images/exco/exco3.jpg'),
        require('./src/assets/images/exco/exco4.jpg'),
        require('./src/assets/images/exco/exco5.jpg'),
        require('./src/assets/images/exco/exco6.jpg'),
        require('./src/assets/images/exco/exco7.jpg'),
        require('./src/assets/images/exco/exco8.jpg'),
        require('./src/assets/images/exco/exco9.jpg'),
        require('./src/assets/images/exco/exco10.jpg')
      ]),
      BatteryService.init(),
      initDownloadedFiles(store),
      init(store)
    ])
    this.setState({ initialised: true })
  }

  render () {
    if (!this.state.initialised) {
      return <CenteredSpinner />
    }

    return (
      <ActualApp store={store} />
    )
  }
}

export default App
